module.exports = {
  CONTENT_API: '//content.api.qa.dice-tools.com/',
  API: '//magnolia-public.qa.dice-tools.com/',
  MAGNOLIA_AUTHOR: '//magnolia-cms.qa.dice-tools.com/',
  MAGNOLIA_PUBLIC: '//magnolia-public.qa.dice-tools.com/'
}
